var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 368 253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffaa3c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fleck_Berlin_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.72,251.57c-16.09,2.51-39.11-3.62-54.25-15.93-6-4.92-11.61-10.63-15.33-17.49C4.65,209.89,3,200.39,2.19,191-3.11,131.14,23.65,69.36,71,32.26,90.46,17,113.52,5.62,138.11,2.56s50.73,2.75,70,18.36c9.79,7.93,17.59,18.13,23.67,29.17,21.48,39,20.6,89.29-2.23,127.48a79.55,79.55,0,0,1-15.36,19.2c-10.37,9.11-23.93,16.7-36.43,22.53C141.22,236.34,94.81,249.06,78.72,251.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.91,226.56c5.87,2.18,18.09.46,24.38-1.27,3-.85,7.11-3.76,9.25-6,10.33-14.41,2.69-40.08-10.23-54C324,138.57,300,175.32,309.3,207,311,219.56,323,224.39,328.91,226.56Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFaq);
export default __webpack_public_path__ + "static/media/bg_faq.c682fb7cb4bbee7b2464aec2f86f3988.svg";
export { ForwardRef as ReactComponent };